/*
  eslint
  react/jsx-filename-extension: off,
  import/no-extraneous-dependencies: off
*/
import ReactDOM from 'react-dom'
import React from 'react'

import Masthead from 'ta-react-masthead'

import isStandalone from '../helpers/isStandalone'

import { mastheadConfig } from '../config/config'

const MastheadComponent = () => {
  if (isStandalone()) {
    ReactDOM.render(
      <Masthead {...mastheadConfig} />,
      document.getElementById('masthead')
    )
  }
  return
}

export default MastheadComponent



// WEBPACK FOOTER //
// ./src/mapSetup/renderMasthead.js